import { useState } from "react";
import { Box, Paper, Typography, Collapse, Divider, Stack } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import ReminderRowTrue from "./RemindersRowTrue";
import { Reminder } from "../../../../../../organization-reminder/interfaces/IRemiders";
import { colors } from "../../../../../../ui/colors";

interface Props {
  title: string;
  icon: React.ReactNode;
  reminders: Reminder[];
  onToggle: (uid: string, isActive: boolean) => void;
  selectedId?: string;
}

export default function ReminderCategoryCard({ title, icon, reminders, onToggle, selectedId }: Props) {
  const [open, setOpen] = useState(true);
  const activeCount = reminders.filter((r) => r.isActive).length;

  return (
    <Paper
      elevation={0}
      sx={{
        border: `1.5px solid ${colors.orange[100]}`,
        borderRadius: "12px",
        overflow: "hidden",
        background: "var(--fx-surface-base, #FFFFFF)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 2,
          py: 1.5,
          cursor: "pointer",
          "&:hover": { background: colors.orange[50] },
          transition: "0.15s",
        }}
        onClick={() => setOpen(!open)}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "10px",
            background: colors.orange[50],
            color: colors.orange.base,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 2,
          }}
        >
          {icon}
        </Box>

        <Box flex={1}>
          <Typography sx={{ fontWeight: 700, fontSize: 14, color: "#3a2a10" }}>{title}</Typography>
          <Typography sx={{ fontSize: 11.5, color: activeCount > 0 ? colors.orange.base : "#bbb", fontWeight: 600 }}>
            {activeCount} Active Reminder{activeCount !== 1 ? "s" : ""}
          </Typography>
        </Box>

        <Box sx={{ color: colors.orange[400] }}>{open ? <ExpandLess /> : <ExpandMore />}</Box>
      </Box>

      <Collapse in={open}>
        <Box sx={{ px: 1.5, pb: 1.5 }}>
          <Divider sx={{ borderColor: colors.orange[100], mb: 1 }} />
          <Stack gap={0.5}>
            {reminders.map((reminder) => (
              <ReminderRowTrue key={reminder.uid} reminder={reminder} onToggle={onToggle} isSelected={selectedId === reminder.uid} />
            ))}
          </Stack>
        </Box>
      </Collapse>
    </Paper>
  );
}
